// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._component-icon-svg[data-v-10cc58be] {\n  width: 100%;\n  width: 20px;\n  height: 20px;\n}\n._component-icon-svg path[data-v-10cc58be] {\n  fill: inherit;\n}\n", ""]);
// Exports
module.exports = exports;
